import * as Styles from './style'

interface ISwitchProps {
  checked: boolean
  handleSwitch: (checkState: boolean) => void
}
export const Switch = (props: ISwitchProps) => {
  const { checked, handleSwitch } = props
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleSwitch(e.target.checked)
  }
  return (
    <Styles.Label>
      <Styles.Input
        checked={checked}
        type='checkbox'
        onChange={handleChange}
        isActive={checked}
      />
      <Styles.SwitchWrapper isActive={checked} />
    </Styles.Label>
  )
}
